module.exports = __webpack_public_path__ + "static/media/file-play.fd7ed954.svg";